import clsx from "clsx";
import { createPortal } from "react-dom";
import { colors } from "../../../../ui/colors";
import { PlusIcon } from "../../../../ui/icons/plus";
import Button from "../../../../ui/molecules/button";
import Input from "../../../../ui/molecules/input";
import { Spinner } from "../../../../ui/molecules/spinner";
import { PersonDTO } from "../dto";

interface Props {
    visible: boolean
    onClose: () => void
    person?: PersonDTO
    phone: string | null
    setPhone: (phone: string | null) => void
    section: "form" | "outcome"
    handleOtpRequest: (phone: string) => void
    isLoading: boolean
}
export function SendOtpModal(props: Props) {
    const { visible, onClose, phone, setPhone, section, person, handleOtpRequest, isLoading } = props

    // useEffect(() => {
    //     if (visible) {
    //         setPhone("")
    //     } else {
    //         setPhone(phone);
    //     }
    // }, [visible])

    const content = (
        <>
            <p className="text-text-md font-medium text-neutral-600 text-center">
                Vuoi richiedere il consenso alla Privacy per
                <span className="font-bold text-neutral-800">
                    { } {person?.name} {person?.surname}
                </span>?
                <br />

                Clicca su '<span className="font-bold text-neutral-800">Invia OTP</span>' per inviare un codice univoco.
            </p>
            <div className="w-1/2">
                <Input
                    placeholder="Inserisci il numero di telefono"
                    startIcon={<div className="text-label-sm text-neutral-600">+39</div>}
                    value={phone ?? ""}
                    onChangeText={setPhone}
                />
            </div>
            {
                isLoading ?
                    <div><Spinner /></div> :
                    <Button disabled={!phone?.trim()} size={"md"} iconPosition={"off"} variant={"solid"} color={"green"} label="Invia OTP"
                        onClick={() => {
                            if (phone?.trim())
                                handleOtpRequest(phone.startsWith('+') ? phone : ("+39" + phone))
                        }}
                    />
            }
        </>
    )

    if (section === "outcome") {
        return content
    }

    return createPortal(
        <div
            onClick={() => onClose()}
            className={clsx(
                "transition-all fixed bg-opacity-30 z-[999] bg-neutral-950 backdrop-blur-sm top-0 left-0 right-0 bottom-0 h-full w-full flex items-center justify-center",
                {
                    block: visible,
                    hidden: !visible,
                }
            )}
        >
            <div
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
                className="transition-all relative bg-white rounded-[12px] opacity-100 shadow-sm min-w-[600px]"
            >
                <div
                    onClick={() => onClose()}
                    className="absolute cursor-pointer rotate-45 top-[-16px] right-[-16px] border border-brandPrimary-600 h-8 w-8 rounded-full flex items-center justify-center bg-brandPrimary-50"
                >
                    <PlusIcon color={colors.brandPrimary[600]} size={16} />
                </div>
                <div className="p-6 text-heading-xs font-semibold text-center">
                    Richiedi Consenso Privacy
                </div>
                <div className="px-6 py-8 flex flex-col justify-center items-center gap-6 border-t-neutral-200 border-t">
                    {content}
                </div>
            </div>
        </div>
        , document.body);
}